import React, {useContext, useState} from 'react'
import {Button, message, Modal, Popconfirm} from "antd"
import {addCustomerToList} from "../../../../services/api/apListCustomers"
import parseToken from "../../../../helpers/parseToken"
import {CustomerManagerContext} from "../../context/CustomerManagerContext"

const CustomerManagerFormModal = (props) => {
    const {showModal, toggleModal, listName, listCusID} = props
    const [item, setItem] = useState({name: "", email: "", phone: ""})
    const [loading, setLoading] = useState(false)
    const [validate, setValidate] = useState({})
    const [setError] = useState('')
    const CustomerManagerPageContext = useContext(CustomerManagerContext)
    const {fetchDetailListCustomers} = CustomerManagerPageContext
    const info = parseToken()

    const _handleChangeInput = (e) => {
        const {name, value} = e.target

        setItem({
            ...item,
            [name]: value.trim()
        })
        setError('')
        delete validate[name]
    }

    const handleCancel = () => {
        toggleModal()
    }

    const _validateData = () => {
        let validateForm = {}

        if (item.name === "" || item.name?.trim() === '') {
            Object.assign(validateForm, {name: 'Tên khách hàng là bắt buộc'})
        }

        if (item.phone === "" || item.phone?.trim() === '') {
            Object.assign(validateForm, {phone: 'Số điện thoại là bắt buộc'})
        }

        setValidate(validateForm)

        return validateForm
    }

    const _addNewCustomer = async () => {
        setLoading(true)

        try {
            const validateCheck = _validateData()

            if (Object.keys(validateCheck).length > 0) {
                setLoading(false)
                setError('Dữ liệu không hợp lệ')

                return false
            }

            const payload = {
                customerListId: listCusID,
                customer: {
                    ...item,
                    createBy: info.sub || 'dongnguyen'
                }
            }
            const response = await addCustomerToList(payload)
            const {success} = response
            if (success !== '1') {
                setLoading(false)

                return message.error("Thêm mới khách hàng không thành công.")
            }

            setLoading(false)
            message.success("Thêm mới khách hàng thành công.")
        } catch (e) {
            message.error(e.message)
        }
    }

    const _resetInfo = () => {
        setItem({})
    }

    const onSave = async () => {
        const response = await _addNewCustomer()

        if (response !== false) {
            if (typeof fetchDetailListCustomers === 'function') {
                await fetchDetailListCustomers()
            }
            handleCancel()
        }
    }

    const onSaveAndNew = async () => {
        const response = await _addNewCustomer()
        if (response !== false) {
            if (typeof fetchDetailListCustomers === 'function') {
                await fetchDetailListCustomers()
            }
            await _resetInfo()
        }
    }

    return <>
        <Modal
            title="Thêm mới Khách hàng"
            className="ModalCustom2 FormAdd"
            maskClosable={false}
            visible={showModal}
            footer={[
                <div className="Actions d-flex justify-content-end align-items-center">
                    <Popconfirm placement="top" title="Bạn chắc chắn muốn thoát?" onConfirm={handleCancel} okText="Yes"
                                cancelText="No">
                        <Button key="back" type="link" disable={loading}>
                            Cancel
                        </Button>
                    </Popconfirm>
                    <Popconfirm placement="top" title="Bạn chắc chắn muốn lưu và tạo mới?" onConfirm={onSaveAndNew}
                                okText="Yes" cancelText="No">
                        <Button key="submit2" loading={loading}>
                            Save & New
                        </Button>
                    </Popconfirm>
                    <Popconfirm placement="top" title="Bạn chắc chắn muốn lưu?" onConfirm={onSave} okText="Yes"
                                cancelText="No">
                        <Button key="submit" type="primary" loading={loading}>
                            Save
                        </Button>
                    </Popconfirm>
                </div>
            ]}
        >
            <div className="FormAddNew">
                <div className="FieldItem">
                    <label className="Label" htmlFor="listName">
                        Tên Danh sách:
                    </label>
                    <input
                        id="listName"
                        value={listName.name || ''}
                        type="text"
                        disabled
                        name="listName"
                    />
                </div>
                <div className={`FieldItem ${validate.name && 'error'}`}>
                    <label className="Label" htmlFor="name">
                        Tên KH:
                        <span className="Required">*</span>
                    </label>
                    <input
                        id="name"
                        value={item.name || ''}
                        type="text"
                        name="name"
                        placeholder="Tên KH"
                        onChange={_handleChangeInput}
                    />
                    {
                        validate.name && <span className="Error text-danger">{validate.name}</span>
                    }
                </div>
                <div className="FieldItem">
                    <label className="Label" htmlFor="email">
                        Email:
                    </label>
                    <input
                        id="email"
                        value={item.email || ''}
                        type="text"
                        name="email"
                        placeholder="Email"
                        onChange={_handleChangeInput}
                    />
                </div>
                <div className={`FieldItem ${validate.phone && 'error'}`}>
                    <label className="Label" htmlFor="phone">
                        Số điện thoại:
                        <span className="Required">*</span>
                    </label>
                    <input
                        id="phone"
                        value={item.phone || ''}
                        type="text"
                        name="phone"
                        placeholder="Số điện thoại 1, Số điện thoại 2 ..."
                        onChange={_handleChangeInput}
                    />
                    {
                        validate.phone && <span className="Error text-danger">{validate.phone}</span>
                    }
                </div>
            </div>
        </Modal>
    </>
}

export default CustomerManagerFormModal
